import Swal from 'sweetalert2'
import IconSuccess from '@/assets/icons/success.svg'
import IconError from '@/assets/icons/error.svg'
import IconWarning from '@/assets/icons/warning.svg'

export default {
    methods: {
        modalSuccess(text, onClose) {
            Swal.fire({
                imageUrl: IconSuccess,
                imageWidth: '67px',
                imageHeight: '68px',
                html: `<p class="auth-alert-modal">${text}</p>`,
                showCloseButton: true,
                showConfirmButton: false,
                width: '450px',
                onClose,
            })
        },
        modalError(text) {
            Swal.fire({
                imageUrl: IconError,
                imageWidth: '77px',
                imageHeight: '77px',
                html: `<p class="auth-alert-modal">${text}</p>`,
                showCloseButton: true,
                showConfirmButton: false,
                width: '450px',
            })
        },
        modalWarning(text) {
            Swal.fire({
                imageUrl: IconWarning,
                imageWidth: '77px',
                imageHeight: '77px',
                html: `<p class="auth-alert-modal">${text}</p>`,
                showCloseButton: true,
                showConfirmButton: false,
                width: '450px',
            })
        },
    },
}
